/** Brief hold on the completed chart before the route loader may dismiss. */
export const LOADING_CHART_CYCLE_HOLD_MS = 500;

/** Matches `.tessera-loading-chart-tile` transition duration. */
export const LOADING_CHART_TILE_TRANSITION_MS = 150;
